import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/* eslint-disable class-methods-use-this */
import awaitCondition from '../utils/awaitCondition';

var EvidonClient = /*#__PURE__*/function () {
  function EvidonClient() {
    _classCallCheck(this, EvidonClient);
  }

  _createClass(EvidonClient, [{
    key: "getPrivacyPreference",

    /**
     * Get the privacy preference value based on Evidon consent requirement
     *
     * @See regulationConsentTypeId
     * https://community.crownpeak.com/t5/Headless-Consent-CaaS/The-Consent-Platform-UCP-JavaScript-API-Documentation/ta-p/7647
     */
    value: function () {
      var _getPrivacyPreference = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this = this;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", awaitCondition(function () {
                  var _window$evidon, _window$evidon$notice, _window$evidon2, _window$evidon2$notic;

                  return ((_window$evidon = window.evidon) === null || _window$evidon === void 0 ? void 0 : (_window$evidon$notice = _window$evidon.notice) === null || _window$evidon$notice === void 0 ? void 0 : _window$evidon$notice.regulationConsentTypeId) !== undefined && ((_window$evidon2 = window.evidon) === null || _window$evidon2 === void 0 ? void 0 : (_window$evidon2$notic = _window$evidon2.notice) === null || _window$evidon2$notic === void 0 ? void 0 : _window$evidon2$notic.consentIsGiven) !== undefined;
                }).then(function () {
                  var _window$evidon3, _window$evidon3$notic;

                  var consentRequirement = (_window$evidon3 = window.evidon) === null || _window$evidon3 === void 0 ? void 0 : (_window$evidon3$notic = _window$evidon3.notice) === null || _window$evidon3$notic === void 0 ? void 0 : _window$evidon3$notic.regulationConsentTypeId;

                  switch (consentRequirement) {
                    case 0:
                      // 0: No consent required
                      return 'exempt';

                    case 1:
                      // 1: Opt-in consent
                      return _this.consentIsGiven() ? 'all' : 'minimal';

                    case 2:
                      // 2: Opt-out consent
                      return _this.consentIsGiven() ? 'all' : 'minimal';

                    default:
                      return 'minimal';
                  }
                }).catch(function () {
                  return 'minimal';
                }));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function getPrivacyPreference() {
        return _getPrivacyPreference.apply(this, arguments);
      }

      return getPrivacyPreference;
    }()
  }, {
    key: "consentIsGiven",
    value: function consentIsGiven() {
      var _window$evidon4, _window$evidon4$notic;

      return !!((_window$evidon4 = window.evidon) === null || _window$evidon4 === void 0 ? void 0 : (_window$evidon4$notic = _window$evidon4.notice) === null || _window$evidon4$notic === void 0 ? void 0 : _window$evidon4$notic.consentIsGiven);
    }
  }]);

  return EvidonClient;
}();

export default EvidonClient;